import { render } from "./FlashSaleProductsComponent.vue?vue&type=template&id=10665abd"
import script from "./FlashSaleProductsComponent.vue?vue&type=script&lang=js"
export * from "./FlashSaleProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/FlashSaleProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10665abd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10665abd', __exports__)) {
    api.reload('10665abd', __exports__)
  }
  
  module.hot.accept("./FlashSaleProductsComponent.vue?vue&type=template&id=10665abd", () => {
    api.rerender('10665abd', render)
  })

}


export default __exports__